import React from 'react';
import classnames from 'classnames';
import Header from './Header';
import DataOverview from './DataOverview';

const DataCardContainer = ({
  title,
  subtitle,
  tooltip,
  dataOverviewIcon,
  dataOverviewIconDescription,
  dataOverviewRoute,
  hasMargin = true,
  children,
  downloadLink,
  reportTitle,
  vertical,
  className,
  direction,
}) => (
  <section
    className={classnames(
      'DataCard',
      children.length > 1 && 'DataCard--containsCards',
      vertical && 'DataCard--vertical',
      hasMargin && 'mb-24',
      className,
    )}
  >
    {title && (
      <Header
        title={title}
        subtitle={subtitle}
        tooltip={tooltip}
        downloadLink={downloadLink}
        reportTitle={reportTitle}
      >
        <DataOverview
          imgSrc={dataOverviewIcon}
          imgDescription={dataOverviewIconDescription}
          dataRoute={dataOverviewRoute}
        />
      </Header>
    )}
    <div
      className={classnames('d-f', 'f-1', {
        'fd-r': children.length > 1 && direction === 'row',
        'fd-c': children.length > 1 && direction === 'column',
      })}
    >
      {children}
    </div>
  </section>
);

export default DataCardContainer;
